import React from 'react';
/**
 * 过滤器参数context
 */
export const FilterDeepContext = React.createContext<{
  backCondConfig: (data: any) => void;
}>({ backCondConfig: () => {} });
